var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { withSkeleton } from '../../Skeleton';
import { ComponentWrapper, OwnSkeleton } from '../styles';
import { useProductLayout } from '../../ProductLayoutProvider';
var BrandWrapper = styled(ComponentWrapper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: bold;\n  text-overflow: ellipsis;\n  font-size: calc(", " - 5px);\n"], ["\n  color: ", ";\n  font-weight: bold;\n  text-overflow: ellipsis;\n  font-size: calc(", " - 5px);\n"])), function (_a) {
    var theme = _a.theme;
    return theme.greyDark.color.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.global.baseFontSize;
});
var BrandName = function (_a) {
    var brand = _a.brand;
    var productLayoutConfig = useProductLayout().productLayoutConfig;
    return brand ? (React.createElement(BrandWrapper, { truncate: productLayoutConfig.truncateStrings, "data-testid": "brandName", marginBottom: ".3rem", paddingH: ".5rem" }, brand.name)) : null;
};
export default withSkeleton(BrandName, function () { return React.createElement(OwnSkeleton, { width: "60%" }); });
var templateObject_1;
//# sourceMappingURL=index.js.map